import React from 'react';
import type { RuntimePolicySurface } from '../../generated/api/types.gen.js';
import { useQuery } from '@tanstack/react-query';
import { runtimePolicyOptionsQuery } from '../../services/api/runtime-policy.queries.js';
import { RuntimePolicyOptionList } from './RuntimePolicyOptionList.js';

interface RuntimePolicyPickerProps {
  surface: RuntimePolicySurface;
  /** Selected policy id; null shows the surface default as selected. */
  value: number | null;
  onChange: (policyId: number) => void;
  disabled?: boolean;
}

/** Choose a runtime policy for a kind of work. People pick policies, never models. */
export const RuntimePolicyPicker: React.FC<RuntimePolicyPickerProps> = ({ surface, value, onChange, disabled }) => {
  const { data: options, isLoading, isError } = useQuery(runtimePolicyOptionsQuery(surface));
  if (isLoading) return <p className="text-xs text-muted">Loading policies…</p>;
  if (isError || !options) return <p className="text-xs text-danger">Could not load runtime policies.</p>;
  if (options.length === 0) return <p className="text-xs text-muted">No runtime policies are allowed for this work.</p>;
  return (
    <RuntimePolicyOptionList
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
      name={`runtime-policy-${surface}`}
    />
  );
};
